<template>
    <div class="icon">
        <svg
            class="w-full h-full fill-current"
            viewBox="0 0 30 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 1.98233C0 1.07162 0.738277 0.333344 1.64899 0.333344H28.351C29.2617 0.333344 30 1.07162 30 1.98233C30 2.89304 29.2617 3.63132 28.351 3.63132H1.64899C0.738277 3.63132 0 2.89304 0 1.98233Z"
                fill="#005BAC"
            />
            <path
                d="M0 11.9995C0 11.0888 0.738277 10.3506 1.64899 10.3506H28.351C29.2617 10.3506 30 11.0888 30 11.9995C30 12.9103 29.2617 13.6485 28.351 13.6485H1.64899C0.738276 13.6485 0 12.9103 0 11.9995Z"
                fill="#005BAC"
            />
            <path
                d="M0 22.0179C0 21.1072 0.738277 20.3689 1.64899 20.3689H28.351C29.2617 20.3689 30 21.1072 30 22.0179C30 22.9286 29.2617 23.6669 28.351 23.6669H1.64899C0.738277 23.6669 0 22.9286 0 22.0179Z"
                fill="#005BAC"
            />
        </svg>
    </div>
</template>

<script>
/**
 * icon-menu、hamburger
 */
export default {
    name: 'IconMenu'
};
</script>

<style scoped>

</style>
